export const UPLOAD_CLEANER_DOCUMENT = 'SAGA/UPLOAD_CLEANER_DOCUMENT';

export const uploadCleanerDocument = (payload) => {
  return {
    type: UPLOAD_CLEANER_DOCUMENT,
    payload,
  };
};
